module.exports = __webpack_public_path__ + "static/fonts/iconfont.213d085.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.ttf?t=1487055721860
// module id = 110
// module chunks = 2